import React from 'react';
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';
import { Image } from "@project-stories/elements/Image/Image";
import useColoredTextParser from '@src/hooks/useColoredTextParser';
import './Promotions.scss';

export const Promotions = ({ settings }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const renderFormattedText = useColoredTextParser({
      title: settings.section.title,
      accentTitleParts: settings.section.highlight_title,
      accentColor: settings.section.highlight_color,
      headerStyle: 'h3 capitalize'
  });

  return (
    <div className={`flex relative overflow-hidden ${isMobile ? 'flex-col px-5 py-12' : 'p-16 gap-16'}`}>
      <div className="background-blur"></div>
      {settings.section.image &&
        <div className={`flex justify-center items-center flex-[1_0_0] flex-shrink-0 ${isMobile ? 'min-w-[335px] min-h-[322px]' : 'min-w-[380px] min-h-[376px]'}`}>
          <Image
            imageUrl={settings.section.image}
            alt={settings.section.title}
            classes={`${isMobile ? 'h-[253px]' : 'h-[376px]'}`}
          />
        </div>
      }
      <div className={`text-center space-y-6 border rounded bg-white/10 ${isMobile ? 'px-4 py-8' : 'px-8 py-12 w-[687px]'}`}>
        <div className="space-y-2">
          {settings.section.tagline &&
            <div className={`capitalize ${isMobile ? 'h6' : 'h7'}`}>
              {settings.section.tagline}
            </div>
          }
          {settings.section.title &&
            renderFormattedText()
          }
        </div>
        <p
          className="b_small_light"
          dangerouslySetInnerHTML={{ __html: settings.section.description }}
        ></p>
        {settings.section.cta_text &&
          <a 
            href={settings.section.cta_url}
            className="inline-flex gap-3 px-5 py-2 rounded-[5px] border border-black bg-[#FBF8F4] hover:bg-[#f1e8de] cursor-pointer"
          >
            <span className="b_a1">{settings.section.cta_text}</span>
            <span className="icon-right-arrow-alt button__icon no-underline"></span>
          </a>
        }
      </div>
    </div>
  )
}

export default Promotions;